import React, { useContext, useState } from "react";

import PropTypes from "prop-types";

import { Form, FormControl } from "react-bootstrap";
import Axios from "axios";
import DashboardContext from "../../Context";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

/**
 * اینپوت شماره موبایل است<br>
 * این کامپوننت عتبار سنجی شماره موبایل رو انجام می دهد<br>
 */
export default function MobileChangeCheckExist({
  label,
  name,
  defaultValue,
  handelValue,
  Placeholder,
  autoComplete,
  urlPorfile,
  handelstatusemobile,
  handleResponse,
  ismodal,
  handelmobileNumber,
  disabled,
  isSmsLog,
  required,
  onChangeFunction,
  newData = null,
  noSearch = false,
}) {
  const { authentication, urldashboard, handelEdit, handelAdd } =
    useContext(DashboardContext);

  const [error, setError] = useState("");

  const [ColorError, setColorError] = useState("");

  const [statuseMobile, setStatuseMobile] = useState(false);

  const [userIDFind, setUserIDFind] = useState("");

  const pattern = new RegExp("[+-]?([0-9]*[.])?[0-9]+");
  // const pattern = new RegExp(/^(0|0098|\+98)9\d{9}$/);

  const handleOnChange = (event) => {
    if (event.target.value) {
      const value = event.target.value;
      if (pattern.test(value)) {
        if (value.length < 10) {
          onChangeFunction();
        } else {
          !noSearch && checkMobileNumber(value);
          setError("شماره موبایل قابل ثبت است");
          setColorError("green");
          handelValue(name, value);
        }
      } else {
        // if (new RegExp(/^[0-9]+$/).test(value)) {
        //   setError("شماره موبایل اشتباه است.");
        //   setColorError("red");
        // } else {
        setError("شماره موبایل فقط به عدد و انگلیسی قابل ثبت است");
        setColorError("red");
        // }
      }
    } else {
      setError("");
      setColorError("");
      handelValue(name, "");
    }
  };

  const checkMobileNumber = async (number) => {
    try {
      const res = await Axios.get(`${urldashboard}/userManagement/checkexist/${number}`, {
        headers: {
          Authorization: authentication,
          "Content-Type": "application/json; charset=utf-8 ",
        },
      });
      const data = await res.data.data;
      setStatuseMobile(data.isAvailable);
      handelstatusemobile(data.isAvailable);
      console.log(data);

      handleResponse(data);
      setUserIDFind(data.userId);
      if (data.isAvailable === true && !isSmsLog) {
        setColorError("red");
        toast.error(" شماره موبایل وارد شده قبلا ثبت شده", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {}
  };
  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <FormControl
        type='text'
        placeholder={Placeholder ? Placeholder : ""}
        name={name ? name : ""}
        autoComplete={autoComplete ? "off" : null}
        defaultValue={defaultValue ? defaultValue : ""}
        dir='ltr'
        disabled={disabled}
        required
        onChange={handleOnChange}
        maxLength='11'
      />
      {error && <Form.Text style={{ color: ColorError }}>{error}</Form.Text>}
    </Form.Group>
  );
}

MobileChangeCheckExist.propTypes = {
  /** تابع ارسال داده به کامپوننت بالا سری است */
  handelValue: PropTypes.func,
};
